import { Head, router } from '@inertiajs/react'
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Typography,
} from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import React from 'react'
import AppLayout from '../../components/layouts/AppLayout'

interface Props {
  success: boolean
  entryName?: string | null
}

export default function Show({ success, entryName }: Props) {
  return (
    <AppLayout>
      <Head title="Unsubscribe" />
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Card>
          <CardContent sx={{ textAlign: 'center', py: 4 }}>
            {success ? (
              <>
                <CheckCircleIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
                <Typography variant="h5" gutterBottom>
                  Unsubscribed
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  You will no longer receive notifications for {entryName}.
                </Typography>
              </>
            ) : (
              <>
                <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
                <Typography variant="h5" gutterBottom>
                  Invalid Link
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                  This unsubscribe link is invalid or has expired.
                </Typography>
              </>
            )}
            <Button variant="contained" onClick={() => router.visit('/apps')}>
              Browse Apps
            </Button>
          </CardContent>
        </Card>
      </Container>
    </AppLayout>
  )
}
